// Forms
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgSelectModule } from '@ng-select/ng-select'

export function FormModules() {
  return [NgSelectModule, FormsModule, ReactiveFormsModule]
}
